import { render, staticRenderFns } from "./ClassificationSection.vue?vue&type=template&id=1cc56f34&"
import script from "./ClassificationSection.vue?vue&type=script&lang=js&"
export * from "./ClassificationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports